var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#018301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc0000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 8c.76190477 0 1.90476191-1.49518772 1.90476191-3.80952381s-1.14285714-3.80952381-1.90476191-3.80952381c-.76190476 0-1.9047619 1.49518772-1.9047619 3.80952381s1.14285714 3.80952381 1.9047619 3.80952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 8c.76190477 0 1.90476191-1.49518772 1.90476191-3.80952381s-1.14285714-3.80952381-1.90476191-3.80952381c-.76190476 0-1.9047619 1.49518772-1.9047619 3.80952381s1.14285714 3.80952381 1.9047619 3.80952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 8c.76190477 0 1.90476191-1.49518772 1.90476191-3.80952381s-1.14285714-3.80952381-1.90476191-3.80952381c-.76190476 0-1.9047619 1.49518772-1.9047619 3.80952381s1.14285714 3.80952381 1.9047619 3.80952381z",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v3.047619h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 8.380952h16v3.047619h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.047619h16v5.333333h-16z",
    fill: "url(#a)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v3.809524h-16z",
    fill: "url(#e)",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(6.095238 1.52381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 8c.76190477 0 1.90476191-1.49518772 1.90476191-3.80952381s-1.14285714-3.80952381-1.90476191-3.80952381c-.76190476 0-1.9047619 1.49518772-1.9047619 3.80952381s1.14285714 3.80952381 1.9047619 3.80952381z",
    fill: "#bc0000"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -1.142857,
    cy: 4.190476,
    fill: "url(#c)",
    mask: "url(#g)",
    rx: 1.904762,
    ry: 4.190476
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.952381,
    cy: 4.190476,
    fill: "url(#c)",
    mask: "url(#h)",
    rx: 1.904762,
    ry: 4.190476
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.9047619 5.33333333c-.21039418 0-.38095238-.51167457-.38095238-1.14285714s.1705582-1.14285714.38095238-1.14285714c.21039419 0 .38095239.51167457.38095239 1.14285714s-.1705582 1.14285714-.38095239 1.14285714zm0-2.28571428c-.21039418 0-.38095238-.68223276-.38095238-1.52380953 0-.84157676.1705582-1.52380952.38095238-1.52380952.21039419 0 .38095239.68223276.38095239 1.52380952 0 .84157677-.1705582 1.52380953-.38095239 1.52380953zm0 5.33333333c-.21039418 0-.38095238-.68223276-.38095238-1.52380952s.1705582-1.52380953.38095238-1.52380953c.21039419 0 .38095239.68223277.38095239 1.52380953s-.1705582 1.52380952-.38095239 1.52380952z",
    fill: "url(#a)",
    mask: "url(#i)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.16a4c72425a12cb6dcecb598a2ffc4c8.svg";
export { ForwardRef as ReactComponent };